/* eslint-disable @stylistic/indent */
// https://docs.microsoft.com/en-us/office/vba/api/office.msolanguageid
export default Object.freeze({
   1078: 'af',    // Afrikaans
   1052: 'sq',    // Albanian
   1118: 'am',    // Amharic
   5121: 'ar_DZ', // Arabic - Algeria
  15361: 'ar_BH', // Arabic - Bahrain
   3073: 'ar_EG', // Arabic - Egypt
   2049: 'ar_IQ', // Arabic - Iraq
  11265: 'ar_JO', // Arabic - Jordan
  13313: 'ar_KW', // Arabic - Kuwait
  12289: 'ar_LB', // Arabic - Lebanon
   4097: 'ar_LY', // Arabic - Libya
   6145: 'ar_MA', // Arabic - Morocco
   8193: 'ar_OM', // Arabic - Oman
  16385: 'ar_QA', // Arabic - Qatar
   1025: 'ar_SA', // Arabic - Saudi Arabia
  10241: 'ar_SY', // Arabic - Syria
   7169: 'ar_TN', // Arabic - Tunisia
  14337: 'ar_AE', // Arabic - United Arab Emirates
   9217: 'ar_YE', // Arabic - Yemen
   1067: 'hy',    // Armenian
   1101: 'as',    // Assamese
   2092: 'az_AZ', // Azeri - Cyrillic
   1068: 'az_AZ', // Azeri - Latin
   1069: 'eu',    // Basque
   1059: 'be',    // Belarusian
   2117: 'bn',    // Bengali - Bangladesh
   1093: 'bn_IN', // Bengali - India
   5146: 'bs',    // Bosnian
   1026: 'bg',    // Bulgarian
   1109: 'my',    // Burmese
   1027: 'ca',    // Catalan
   2052: 'zh_CN', // Chinese - China
   3076: 'zh_HK', // Chinese - Hong Kong SAR
   5124: 'zh_MO', // Chinese - Macau SAR
   4100: 'zh_SG', // Chinese - Singapore
   1028: 'zh_TW', // Chinese - Taiwan
   1050: 'hr',    // Croatian
   1029: 'cs',    // Czech
   1030: 'da',    // Danish
   1125: 'dv',    // Divehi; Dhivehi; Maldivian
   2067: 'nl_BE', // Dutch - Belgium
   1043: 'nl_NL', // Dutch - Netherlands
   1126: 'bin',   // Edo
   3081: 'en_AU', // English - Australia
  10249: 'en_BZ', // English - Belize
   4105: 'en_CA', // English - Canada
   9225: 'en_CB', // English - Caribbean
   2057: 'en_GB', // English - Great Britain
  16393: 'en_IN', // English - India
   6153: 'en_IE', // English - Ireland
   8201: 'en_JM', // English - Jamaica
   5129: 'en_NZ', // English - New Zealand
  13321: 'en_PH', // English - Phillippines
   7177: 'en_ZA', // English - Southern Africa
  11273: 'en_TT', // English - Trinidad
   1033: 'en_US', // English - United States
  12297: 'en_ZW', // English - Zimbabwe
   1061: 'et',    // Estonian
   1071: 'mk',    // FYRO Macedonia
   1080: 'fo',    // Faroese
   1065: 'fa',    // Farsi - Persian
   1124: 'fil',   // Filipino
   1035: 'fi',    // Finnish
   2060: 'fr_BE', // French - Belgium
  11276: 'fr_CM', // French - Cameroon
   3084: 'fr_CA', // French - Canada
   9228: 'fr_CG', // French - Congo
  12300: 'fr_CI', // French - Cote d'Ivoire
   1036: 'fr_FR', // French - France
   5132: 'fr_LU', // French - Luxembourg
  13324: 'fr_ML', // French - Mali
   6156: 'fr_MC', // French - Monaco
  14348: 'fr_MA', // French - Morocco
  10252: 'fr_SN', // French - Senegal
   4108: 'fr_CH', // French - Switzerland
   7180: 'fr',    // French - West Indies
   1122: 'fy_NL', // Frisian - Netherlands
   2108: 'gd_IE', // Gaelic - Ireland
   1084: 'gd',    // Gaelic - Scotland
   1110: 'gl',    // Galician
   1079: 'ka',    // Georgian
   3079: 'de_AT', // German - Austria
   1031: 'de_DE', // German - Germany
   5127: 'de_LI', // German - Liechtenstein
   4103: 'de_LU', // German - Luxembourg
   2055: 'de_CH', // German - Switzerland
   1032: 'el',    // Greek
   1140: 'gn',    // Guarani - Paraguay
   1095: 'gu',    // Gujarati
   1279: 'en',    // HID (Human Interface Device)
   1037: 'he',    // Hebrew
   1081: 'hi',    // Hindi
   1038: 'hu',    // Hungarian
   1039: 'is',    // Icelandic
   1136: 'ig_NG', // Igbo - Nigeria
   1057: 'id',    // Indonesian
   1040: 'it_IT', // Italian - Italy
   2064: 'it_CH', // Italian - Switzerland
   1041: 'ja',    // Japanese
   1099: 'kn',    // Kannada
   1120: 'ks',    // Kashmiri
   1087: 'kk',    // Kazakh
   1107: 'km',    // Khmer
   1111: 'kok',   // Konkani
   1042: 'ko',    // Korean
   1088: 'ky',    // Kyrgyz - Cyrillic
   1108: 'lo',    // Lao
   1142: 'la',    // Latin
   1062: 'lv',    // Latvian
   1063: 'lt',    // Lithuanian
   2110: 'ms_BN', // Malay - Brunei
   1086: 'ms_MY', // Malay - Malaysia
   1100: 'ml',    // Malayalam
   1082: 'mt',    // Maltese
   1112: 'mni',   // Manipuri
   1153: 'mi',    // Maori
   1102: 'mr',    // Marathi
   1104: 'mn',    // Mongolian
   2128: 'mn',    // Mongolian
   1121: 'ne',    // Nepali
   1044: 'no_NO', // Norwegian - Bokml
   2068: 'no_NO', // Norwegian - Nynorsk
   1096: 'or',    // Oriya
   1045: 'pl',    // Polish
   1046: 'pt_BR', // Portuguese - Brazil
   2070: 'pt_PT', // Portuguese - Portugal
   1094: 'pa',    // Punjabi
   1047: 'rm',    // Raeto-Romance
   2072: 'ro_MO', // Romanian - Moldova
   1048: 'ro_RO', // Romanian - Romania
   1049: 'ru',    // Russian
   2073: 'ru_MO', // Russian - Moldova
   1083: 'se',    // Sami Lappish
   1103: 'sa',    // Sanskrit
   3098: 'sr_SP', // Serbian - Cyrillic
   2074: 'sr_SP', // Serbian - Latin
   1072: 'st',    // Sesotho (Sutu)
   1074: 'tn',    // Setsuana
   1113: 'sd',    // Sindhi
   1115: 'si',    // Sinhala; Sinhalese
   1051: 'sk',    // Slovak
   1060: 'sl',    // Slovenian
   1143: 'so',    // Somali
   1070: 'sb',    // Sorbian
  11274: 'es_AR', // Spanish - Argentina
  16394: 'es_BO', // Spanish - Bolivia
  13322: 'es_CL', // Spanish - Chile
   9226: 'es_CO', // Spanish - Colombia
   5130: 'es_CR', // Spanish - Costa Rica
   7178: 'es_DO', // Spanish - Dominican Republic
  12298: 'es_EC', // Spanish - Ecuador
  17418: 'es_SV', // Spanish - El Salvador
   4106: 'es_GT', // Spanish - Guatemala
  18442: 'es_HN', // Spanish - Honduras
   2058: 'es_MX', // Spanish - Mexico
  19466: 'es_NI', // Spanish - Nicaragua
   6154: 'es_PA', // Spanish - Panama
  15370: 'es_PY', // Spanish - Paraguay
  10250: 'es_PE', // Spanish - Peru
  20490: 'es_PR', // Spanish - Puerto Rico
   1034: 'es_ES', // Spanish - Spain (Traditional)
  14346: 'es_UY', // Spanish - Uruguay
   8202: 'es_VE', // Spanish - Venezuela
   1089: 'sw',    // Swahili
   2077: 'sv_FI', // Swedish - Finland
   1053: 'sv_SE', // Swedish - Sweden
   1114: 'syc',   // Syriac
   1064: 'tg',    // Tajik
   1097: 'ta',    // Tamil
   1092: 'tt',    // Tatar
   1098: 'te',    // Telugu
   1054: 'th',    // Thai
   1105: 'bo',    // Tibetan
   1073: 'ts',    // Tsonga
   1055: 'tr',    // Turkish
   1090: 'tk',    // Turkmen
   1058: 'uk',    // Ukrainian
   1056: 'ur',    // Urdu
   2115: 'uz_UZ', // Uzbek - Cyrillic
   1091: 'uz_UZ', // Uzbek - Latin
   1075: 've',    // Venda
   1066: 'vi',    // Vietnamese
   1106: 'cy',    // Welsh
   1076: 'xh',    // Xhosa
   1085: 'yi',    // Yiddish
   1077: 'zu'     // Zulu
});
